import {
  Captions,
  Crop,
  Eraser,
  Loader2,
  type LucideIcon,
  PenTool,
  PencilLine,
  Sparkles,
  Trash2,
  Users,
} from 'lucide-react'
import type { PhotoActionIconKey } from '@/lib/photos/photo-action-items'

/** The icon component for each photo action's icon key. */
export const PHOTO_ACTION_ICONS: Record<PhotoActionIconKey, LucideIcon> = {
  'pencil-line': PencilLine,
  sparkles: Sparkles,
  crop: Crop,
  users: Users,
  'pen-tool': PenTool,
  eraser: Eraser,
  captions: Captions,
  trash: Trash2,
}

/** Shown in place of an action's icon while it runs (Remove background). */
export const PHOTO_ACTION_LOADING_ICON = Loader2
